import { BrowserRouter as Router } from "react-router-dom";

import * as Sentry from "@sentry/browser";
import { keepPreviousData, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { init } from "@telegram-apps/sdk-react";
import { TonConnectUIProvider } from "@tonconnect/ui-react";
import { NuqsAdapter } from "nuqs/adapters/react-router";

import { ErrorBoundary, ErrorBoundaryError } from "@/components/ErrorBoundary";

import { AuthLayer } from "./AuthLayer";
import { I18NLayer } from "./I18NLayer";
import { MainRoutes } from "./Routes";
import { TMALayer } from "./TMALayer";

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: "https://1d6f6cc1a2d24649909fd66f80d0b542@glitchtip.architecton.site/5",
    environment: "production",
  });
}

init();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000, // 30 sec
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      placeholderData: keepPreviousData,
    },
  },
});

export const App = () => (
  <ErrorBoundary fallback={ErrorBoundaryError}>
    <TonConnectUIProvider
      actionsConfiguration={{
        skipRedirectToWallet: "never",
      }}
      manifestUrl="https://manifest.architecton.site/tonconnect-manifest.json"
    >
      <QueryClientProvider client={queryClient}>
        <TMALayer>
          <I18NLayer>
            <AuthLayer>
              <NuqsAdapter>
                <Router>
                  <MainRoutes />
                </Router>
              </NuqsAdapter>
            </AuthLayer>
          </I18NLayer>
        </TMALayer>
      </QueryClientProvider>
    </TonConnectUIProvider>
  </ErrorBoundary>
);
